// Webpack Imports
import * as bootstrap from 'bootstrap'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)
;(function () {
  ;('use strict')

  // GSAP scrollTrigger display element
  // var pageHeader = $('.navbar-brand')
  // var anim_header = gsap.timeline({
  //   scrollTrigger: {
  //     trigger: $('body'),
  //     scrub: true,
  //     // markers: true,
  //     start: 'top top',
  //     end: '+=' + 10 + 'px'
  //   }
  // })

  // // scroll animation
  // anim_header.to(pageHeader, {
  //   y: -150,
  //   duration: '0.2'
  // })

  // GSAP scrollTrigger display element
  const displayImg = document.querySelector('.third-block')
  gsap.to(displayImg, {
    backgroundPosition: '50% 0',
    scrollTrigger: {
      trigger: displayImg,
      start: 'top 50%', // the default values
      end: 'bottom 60%',
      scrub: true,
      markers: false
    }
  })

  // Sticky toolbar
  const stickyIconToolBar = document.getElementById('stickyIconToolBar')
  const closeBtn = document.querySelector('.close-btn')
  var hover = false

  // iconToolBar Mouseover
  stickyIconToolBar.addEventListener(
    'mouseover',
    function (event) {
      if (!hover) {
        closeBtn.style.top = '-1rem'
      }
      hover = true
    },
    false
  )

  // iconToolBar Mouseleave
  stickyIconToolBar.addEventListener(
    'mouseleave',
    function (event) {
      hover = false
      closeBtn.style.top = '0.1rem'
    },
    false
  )

  // Close button
  closeBtn.addEventListener('click', function (event) {
    stickyIconToolBar.classList.add('hide-toolbar')
    sessionStorage.setItem('toolbar', 'closed')
  })

  setTimeout(() => {
    stickyIconToolBar.classList.remove('hide-toolbar')
  }, 3000)

  // Scrolltop
  let scrollToTopBtn = document.querySelector('.scrollToTopBtn')
  let rootElement = document.documentElement

  function handleScroll() {
    // Do something on scroll
    let scrollTotal = rootElement.scrollHeight - rootElement.clientHeight
    if (rootElement.scrollTop / scrollTotal > 0.7) {
      // Show button
      scrollToTopBtn.classList.add('showBtn')
    } else {
      // Hide button
      scrollToTopBtn.classList.remove('showBtn')
    }
  }

  function scrollToTop() {
    // Scroll to top logic
    rootElement.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  scrollToTopBtn.addEventListener('click', scrollToTop)
  document.addEventListener('scroll', handleScroll)

  window.onscroll = function () {
    scrollFunction()
  }

  const headerLogo = document.getElementById('headerLogo')

  // On scroll
  function scrollFunction() {
    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
      headerLogo.classList.add('move-up')
    } else {
      headerLogo.classList.remove('move-up')
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
      headerLogo.classList.add('move-up')
    } else {
      headerLogo.classList.remove('move-up')
    }
  })

  // Menu modal
  let menuModal = document.getElementById('menuModal')
  let navbarButton = document.getElementById('navbarButton')

  menuModal.addEventListener('show.bs.modal', function () {
    let nav = document.getElementById('menu-primary').getElementsByTagName('li')

    for (var i = 0; i < nav.length; i++) {
      // var element = elementsArray[i]
      // console.log(i)
      // if (i.classList.contains('current-menu-parent')) {
      //   console.log('Found current-menu-parent')
      // }
    }

    navbarButton.style.display = 'none'

    if (headerLogo.classList.contains('move-up')) {
      headerLogo.classList.remove('move-up')
    }
  })

  menuModal.addEventListener('hide.bs.modal', function () {
    navbarButton.style.display = 'flex'

    if (document.body.scrollTop > 0 || document.documentElement.scrollTop > 0) {
      headerLogo.classList.add('move-up')
    } else {
      headerLogo.classList.remove('move-up')
    }
  })

  // // Menu hover
  // let hasChildren = document.querySelectorAll('.menu-item-has-children')

  // hasChildren.forEach(e => {
  //   e.addEventListener(
  //     'mouseover',
  //     function (event) {
  //       let link = this.querySelectorAll('.dropdown-toggle')
  //       let list = this.querySelectorAll('.dropdown-menu')
  //       if (!hover) {
  //         link[0].classList.add('show')
  //         list[0].classList.add('show')
  //       }
  //       hover = true
  //     },
  //     false
  //   )

  //   e.addEventListener(
  //     'mouseleave',
  //     function (event) {
  //       let link = this.querySelectorAll('.dropdown-toggle')
  //       let list = this.querySelectorAll('.dropdown-menu')
  //       link[0].classList.remove('show')
  //       list[0].classList.remove('show')
  //       hover = false
  //     },
  //     false
  //   )
  // })
})()
